<template>
  <div class="serviceliststyle">
    <el-form
      label-width="90px"
      :model="datas"
      size="small"
      class="lef"
      style="margin-top: 20px"
    >
      <el-form-item label="模块名称：">
        <div class="weiz">
          <div class="ml35">
            <el-input disabled v-model="datas.moduleName"></el-input>
          </div>
        </div>
      </el-form-item>
      <div>
        <vuedraggable v-model="datas.imageList" v-bind="dragOptions">
          <transition-group>
            <section
              v-for="(item, index) in datas.imageList"
              :key="item + index"
            >
              <div class="imgBanner" style="border: 1px solid red">
                <!-- 图片 -->
                <div class="imag">
                  <img
                    draggable="false"
                    :src="item.src"
                    alt=""
                    @click="handleUploadImage(item, index)"
                  />
                </div>
                <div style="width: 100%">
                  <!-- 标题和链接 -->
                  <div class="imgText" style="align-items: center">
                    <el-input
                      v-model="item.text"
                      placeholder="导航名称"
                      size="mini"
                    />
                    <i class="el-icon-delete" @click="deleteimg(index)" />
                  </div>
                  <!-- 标题和链接 -->
                  <div style="padding-left: 20px; margin-top: 10px">
                    <CustomSelectList
                      :id="datas.id"
                      :datas="item"
                      :isShow="true"
                      :index="index"
                    />
                  </div>
                </div>
              </div>
            </section>
          </transition-group>
        </vuedraggable>
      </div>
    </el-form>
    <!-- 上传图片 -->
    <image-select-modal
      ref="imageSelectModal"
      :isImageLib="false"
      :activeTab="'myFiles'"
      :visible.sync="showImageModal"
      @select="handleImageSelect"
    />
  </div>
</template>

<script>
export default {
  name: "servicenavigationstyle",
  props: {
    datas: Object,
  },
  data() {
    return {
      // 拖拽配置
      dragOptions: {
        animation: 200,
      },
      showImageModal: false, //显示上传图片弹窗
      currentItemIndex: {}, //当前点击的图片项
    };
  },
  methods: {
    // 上传图片点击事件
    handleUploadImage(item, index) {
      this.showImageModal = true;
      this.currentItemIndex = index;
      console.log("handleUploadImage方法回调", item, index, this.datas);
    },
    // 上传图片确定回调函数
    handleImageSelect(res) {
      this.datas.imageList[this.currentItemIndex].src = res.url;
      console.log(
        "image-select-modal确定函数回调方法",
        res,
        this.datas,
        this.currentItemIndex,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.serviceliststyle {
}

.lef {
  margin-bottom: 20px;
}

.weiz {
  display: flex;
  align-items: center;
}

.ml35 {
  margin-left: 35px;
  flex: 1;
}
</style>
